import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon, HandshakeIcon, LanguagesIcon, ScanSearchIcon, WrenchIcon } from 'lucide-react';
import { copy } from '../../data/copy';
import { useLanguage } from '../../contexts/LanguageContext';
import { SectionHeading } from '../SectionHeading';
const icons = [ScanSearchIcon, WrenchIcon, HandshakeIcon, LanguagesIcon];
export function WhyChoose() {
  const {
    t
  } = useLanguage();
  return <section className="bg-white py-16 sm:py-20" data-id="element-280" data-mp="3j6nsgn8ee9jn">
      <div className="mx-auto max-w-7xl px-6" data-id="element-281" data-mp="3nzqnz0wqjt2h">
        <SectionHeading title={t(copy.why.title)} description={t(copy.why.description)} data-id="element-282" data-mp="3o1jzatian1gt" />
        <div className="mt-12 grid gap-x-10 gap-y-10 sm:grid-cols-2 lg:grid-cols-4" data-id="element-283" data-mp="3e9nmsdfgn8t2">
          {copy.why.cards.map((card, index) => {
          const Icon = icons[index];
          return <article key={card.title.en} className="group flex h-full flex-col" data-id="element-284" data-mp="358zjacnp0quf" data-mpi={index}>
                <span className="inline-flex h-12 w-12 items-center justify-center rounded-md bg-gold-100 text-gold-700" data-id="element-285" data-mp="3p8hn2hhe3iso">
                  <Icon width={24} height={24} aria-hidden="true" data-id="element-286" data-mp="3l6w72n9k6oe9" />
                </span>
                <h3 className="mt-5 font-display text-lg font-bold text-navy-900" data-id="element-287" data-mp="30zt9w12pct2">
                  {t(card.title)}
                </h3>
                <p className="mt-2 leading-relaxed text-navy-600" data-id="element-288" data-mp="3u69ihlh8tn1m">
                  {t(card.body)}
                </p>
                <Link to={card.to} className="mt-auto inline-flex items-center gap-1.5 pt-5 text-sm font-bold text-navy-900 transition-colors duration-150 ease-smooth hover:text-gold-600" data-id="element-289" data-mp="31jom26lwukr7">
                  {t(card.cta)}
                  <ArrowRightIcon width={16} height={16} aria-hidden="true" className="transition-transform duration-200 ease-smooth group-hover:translate-x-1" data-id="element-290" data-mp="3bfrrblc26zid" />
                </Link>
              </article>;
        })}
        </div>
      </div>
    </section>;
}